import {get,post} from '@/axios'
//用户登录
export const userLogin = p =>post('login/userLogin',p);
export const userLoginByAccessKeyToken = p =>post('login/userLoginByAccessKeyToken',p);
export const userLoginOut = p =>post('login/loginOut',p);



// WEBPACK FOOTER //
// ./src/api/system/login.js